import { useCartStore } from '~/store/cart'
import { useIdentity } from '~/store/identity'
import type { IClientInterface } from '~/types/auth/identityTypes'

const getCanReserve = (isAlt: boolean, user: IClientInterface | null, price?: number) => {
  if (!user || !isAlt) {
    return false
  }

  if ((user.order_now_limit ?? 0) < (price ?? 0)) {
    return false
  }

  return user?.can_reserve && user.is_solvent
}

export const useMpReservation = (totalPrice?: globalThis.ComputedRef<number>) => {
  const identity = useIdentity()
  const cart = useCartStore()
  const { isAlt } = useTheme()

  const price = computed(() => totalPrice?.value ?? cart.totalSum)
  const canReserve = ref(getCanReserve(isAlt, identity.user, price.value))

  const stopWatch = watch(
    () => [identity.user, price],
    ([newUserData, newPrice]) => {
      if (newPrice && 'value' in newPrice) {
        canReserve.value = getCanReserve(isAlt, newUserData as IClientInterface | null, newPrice.value)
      }
    },
    {
      deep: true,
    }
  )

  onBeforeUnmount(() => {
    stopWatch()
  })

  return {
    user: identity.user,
    canReserve,
  }
}
